export enum NameConvention {
  Western = 'wester',
  Eastern = 'eastern'
}
